import { createSharedState } from '@ai-indeed/hooks';
import { TabEnum, type Tabs } from '../type';

export const useFormDirty = createSharedState<boolean>(false);
